<template>
  <md-toolbar
    md-elevation="0"
    class="md-transparent"
    :class="{
      'md-toolbar-absolute md-white md-fixed-top': $route.meta.navbarAbsolute,
    }"
  >
    <div class="overlay" v-if="loader">
      <md-progress-spinner
        :md-diameter="100"
        class="md-accent spinner-postion"
        :md-stroke="7"
        md-mode="indeterminate"
      ></md-progress-spinner>
    </div>
    <div class="md-toolbar-row">
      <div class="md-toolbar-section-start" style="margin-right: 10px">
        <md-button class="md-raised md-danger vendor-btn">{{ 
         $route.query.params=='party-dashboard'?'Vendor OS': $route.name
        }}</md-button>
      </div>

      <div
        v-if="
          $store.state.auth.vendorPortalAdmin == 'PARTY_REQ_ADMIN' &&
          $route.name == 'Dashboard'
        "
        class="md-toolbar-selection-start"
      >
        <md-button
          class="md-raised md-card-header-purple routeClass vendor-btn"
          @click="routeFunction()"
          >Change Vendor</md-button
        >
      </div>
      <!-- <div v-if="$route.name !== 'Admin Page'"> -->
      <!-- v-if="userType == 'PARTY' && $route.name !== 'Routing'" -->

      <div
        class="md-toolbar-section-start"
        v-if="userType == 'PARTY' && $route.name !== 'Routing' && $route.name !== 'Change Password'"
      >
        <div class="md-size-15">
          <md-field>
            <md-select name="leId" id="leId" v-model="leId" md-dense>
              <!-- <md-option value="All"></md-option> -->
              <md-option
                v-for="(item, index) in legalEntity"
                :key="index"
                :value="item.le_id"
                >{{ item.le_name }}</md-option
              >
            </md-select>
          </md-field>
        </div>
      </div>
      <div
        class="md-toolbar-section-start"
        style="margin: 0 10px"
        v-if="userType == 'PARTY' && $route.name !== 'Routing' && $route.name !== 'Change Password'"
      >
        <div class="md-size-15">
          <md-field>
            <md-select name="finYear" v-model="finYear" md-dense>
              <md-option value="All">{{ currentFinYear }}</md-option>
              <md-option
                v-for="(item, index) in financialYearList"
                :key="index"
                :value="item.fy_display"
                >{{ item.fy_display }}</md-option
              >
            </md-select>
          </md-field>
        </div>
      </div>
      <div
        v-if="
          $route.name !== 'Admin Page' &&
          $route.name !== 'Routing' &&
          userType !== 'PARTY'
        "
        style="margin-top: 5px; margin-left: 20px"
      >
        <div class="marque-bg">
          <p style="text-align: center" class="marque-text">
            Support Email :- vendorportal.support@delhivery.com
          </p>
        </div>
      </div>

      <div
        v-if="$route.name !== 'Admin Page' && $route.name !== 'Routing'"
        style="margin-top: 5px; margin-left: 2rem"
      >
        <div class="marque-bg">
          <p style="text-align: center" class="marque-text">
            Welcome :- <b>{{ partyName }}</b>
          </p>
        </div>
      </div>
      <!-- </div> -->
      <a
        target="_blank"
        class="md-layout-item md-small-size-100 md-size-10"
        v-if="$route.name === 'Party Onboarding'"
        :href="downloadDocUrl + '/' + fileName"
      >
        <md-button class="md-raised md-rose search-btn vendor-btn"
          >Process Manual</md-button
        >
      </a>
      <a
        target="_blank"
        class="md-layout-item md-small-size-100 md-size-10"
        v-if="$route.name === 'Vendor Invoice Entry'"
      >
        <md-button
          class="md-raised md-rose search-btn vendor-btn"
          :href="downloadDocUrl + '/' + invoiceFileName"
          >User Manual</md-button
        >
      </a>
            <drop-down
        class="manual-videos-dropdown"
        v-if="$route.name === 'Vendor Invoice Entry'"
      >
        <md-button
          slot="title"
          class="md-raised md-rose search-btn vendor-btn dropdown-toggle"
          data-toggle="dropdown"
          >Manual Videos</md-button
        >
        <ul class="dropdown-menu dropdown-menu-right">
          <li
            v-for="video in manualVideos"
            :key="video.fileName"
            class="manual-video-item"
          >
            <span class="manual-video-label">{{ video.label }}</span>
            <span class="manual-video-actions">
              <a
                href="#"
                title="Preview"
                @click.prevent="previewManualVideo(video.fileName)"
                ><md-icon>visibility</md-icon></a
              >
              <a
                href="#"
                title="Download"
                @click.prevent="downloadManualVideo(video.fileName)"
                ><md-icon>file_download</md-icon></a
              >
            </span>
          </li>
        </ul>
      </drop-down>
      <router-link
        to="/dashboard"
        v-if="$route.name === 'Vendor Invoice Entry'"
      >
        <div
          class="letsTalk"
          type="button"
          data-bs-toggle="modal"
          data-bs-target="#staticBackdrop"
          title="Return to Dashboard"
        >
          <div id="telephoneIcon">
            <md-icon style="color: black">home</md-icon>
          </div>
        </div>
      </router-link>
      <div class="md-toolbar-section-end">
        <div class="md-collapse">
          <md-list>
            <md-list-item
              :style="
                $route.name == 'Admin Page' ? 'background-color:white;' : ''
              "
            >
              <router-link style="" to="/settings/change-password">
                <i class="material-icons" title="Change Password">lock</i>
              </router-link>
            </md-list-item>
            <md-list-item
              :style="
                $route.name == 'Admin Page' ? 'background-color:white;' : ''
              "
              @click="logOutUser"
            >
              <i class="material-icons" title="Logout">logout</i>
              <p class="hidden-lg hidden-md">Profile</p>
            </md-list-item>
          </md-list>
        </div>
      </div>
    </div>
  </md-toolbar>
</template>

<script>
import URL_UTILITY from "../../../utility/url.utility";
import appStrings from "../../../utility/string.utility";
export default {
  components: {},
  watch: {
    leId: function (id) {
      sessionStorage.setItem("leId", id);
      this.$store.dispatch("shared/setLeId", id);
    },
    finYear: function (year) {
      sessionStorage.setItem("finYear", year);
      this.$store.dispatch("shared/setFinYear", year);
    },
    currentFinYear: function (currentYear) {
      sessionStorage.setItem("currentFinYear", currentYear);
      this.$store.dispatch("shared/setCurrentFinYear", currentYear);
    },
  },
  data() {
    return {
      selectedEmployee: "",
      employees: [
        "Jim Halpert",
        "Dwight Schrute",
        "Michael Scott",
        "Pam Beesly",
        "Angela Martin",
        "Kelly Kapoor",
        "Ryan Howard",
        "Kevin Malone",
      ],
      documentationLink:
        "https://vue-material-dashboard-laravel.creative-tim.com/documentation/",
      downloadUrl:
        "https://www.creative-tim.com/product/vue-material-dashboard-laravel",
      unsubscribe: null,
      loader: false,
      legalEntity: [],
      financialYearList: [],
      finYear: "All",
      leId: null,
      currentFinYear: null,
      userType: null,
      partyName: null,
      showManualModal: false,
      downloadDocUrl: URL_UTILITY.getManualDocumentUrl,
      fileName: appStrings.MANUALFILENAME,
      downloadVideoUrl: URL_UTILITY.getManualVideoUrl,
      invoiceFileName: appStrings.INVOICEFILENAME,
      manualVideos: [
        { label: "Credit Note (with PO)", fileName: appStrings.CREDIT_NOTE_INVOICE_WITH_PO_FILENAME },
        { label: "Credit Note (without PO)", fileName: appStrings.CREDIT_NOTE_INVOICE_WITHOUT_PO_FILENAME },
        { label: "Ad-hoc Credit Note", fileName: appStrings.ADHOC_CREDIT_NOTE_FILENAME },
        { label: "Invoice (without PO)", fileName: appStrings.INVOICE_WITHOUT_PO_FILENAME },
        { label: "Invoice (with PO)", fileName: appStrings.INVOICE_WITH_PO_FILENAME },
        { label: "GRN Manual", fileName: appStrings.GRN_FILENAME },
      ],
    };
  },
  created() {
    this.eventBus.$on("vendorName", (vendorName) => {
      this.partyName = vendorName;
    });
  },
  mounted() {
    this.userType = sessionStorage.getItem("userType");
    this.leId = sessionStorage.getItem("leId")
      ? sessionStorage.getItem("leId")
      : "All";
    this.finYear = sessionStorage.getItem("finYear")
      ? sessionStorage.getItem("finYear")
      : "All";
    this.getVendorPartyName();
    this.getLegalEntity();
    this.getFinancialYear();
    this.unsubscribe = this.$store.subscribe((mutation, state) => {
      if (mutation.type === "shared/setLoader") {
        this.loader = state.shared.loader;
      }
    });
    if (this.$store.state.auth.partyId) {
      this.partyName = this.getName();
    }
    this.eventBus.$on("vendorName", (vendorName) => {
      this.partyName = vendorName;
    });
    this.eventBus.$on("partyName", (partyName) => {
      this.partyName = partyName;
    });
  },
  updated() {
    this.userType = sessionStorage.getItem("userType");
    // this.getVendorPartyName();
  },
  methods: {
    routeFunction() {
      this.$router.push({ name: "Admin Page" });
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize();
      }
    },
    goToNotifications() {
      this.$router.push({ name: "Notifications" });
    },
    logOutUser() {
      this.$store.dispatch("logout");
    },
    getName() {
      const payload = {
        party_req_id: this.$store.state.auth.partyId,
      };
      this.loader = true;
      this.$store.dispatch("shared/setLoader", true);
      this.$store
        .dispatch("vendor/getVendorDetails", payload)
        .then((resp) => {
          this.loader = false;
          this.$store.dispatch("shared/setLoader", false);
          if (resp.status === 200) {
            const result = resp.data.data;
            this.partyName = result.name;
          }
        })
        .catch(() => {
          this.loader = false;
          this.$store.dispatch("shared/setLoader", false);
        });
    },
    getVendorPartyName() {
      if (this.userType == "VENDOR") {
        this.getName();
      } else if (this.userType == "PARTY") {
        this.getPartyName();
      }
    },
    getLegalEntity() {
      const payload = {
        _page: 0,
        _limit: 100,
      };
      this.$store.dispatch("shared/getLegalEntity", payload).then((resp) => {
        if (resp.status === 200) {
          this.legalEntity = resp.data.data.page;
          if (this.legalEntity.length > 0) {
            this.leId = this.legalEntity[0].le_id;
          }
        }
      });
    },
    getFinancialYear() {
      this.$store.dispatch("shared/getFinancialYear").then((resp) => {
        if (resp.status === 200) {
          this.financialYearList = resp.data.data;
          // this.currentFinYear = this.financialYearList[0].current_financial_year;
          this.currentFinYear = "ALL";
          sessionStorage.setItem("currentFinYear", this.currentFinYear);
          this.$store.dispatch("shared/setCurrentFinYear", this.currentFinYear);
        }
      });
    },
    getPartyName() {
      this.$store.dispatch("party/getDetails", "details").then((resp) => {
        if (resp.status === 200) {
          this.partyName = resp.data.data.party_details.party_name;
        }
      });
    },
    fetchManualVideo(fileName) {
      return this.$store
        .dispatch("vendor/getManualVideo", fileName)
        .then((response) => {
          if (!response || response.status !== 200) {
            throw new Error("Video request failed");
          }
          const headerType = response.headers["content-type"] || "";
          const contentType = headerType.startsWith("video/")
            ? headerType
            : "video/mp4";
          return {
            contentType,
            blob: new Blob([response.data], { type: contentType }),
          };
        });
    },
    downloadManualVideo(fileName) {
      this.$store.dispatch("shared/setLoader", true);
      this.fetchManualVideo(fileName)
        .then(({ contentType, blob }) => {
          const extension = contentType.split("/")[1].split(";")[0] || "mp4";
          const videoUrl = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = videoUrl;
          link.download = `${fileName}.${extension}`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          setTimeout(() => window.URL.revokeObjectURL(videoUrl), 1000);
        })
        .catch(() => {
          alert("Unable to download the video. Please try again.");
        })
        .finally(() => {
          this.$store.dispatch("shared/setLoader", false);
        });
    },
    previewManualVideo(fileName) {
      // Open the tab synchronously on click so the browser doesn't block it as a popup
      const videoWindow = window.open("", "_blank");
      if (!videoWindow) {
        alert("Please allow pop-ups for this site to play the video.");
        return;
      }
      videoWindow.document.title = "Loading video...";
      videoWindow.document.body.innerHTML =
        "<p style='font-family:sans-serif;padding:16px'>Loading video...</p>";
      this.fetchManualVideo(fileName)
        .then(({ blob }) => {
          const videoUrl = window.URL.createObjectURL(blob);
          const doc = videoWindow.document;
          doc.title = fileName;
          doc.body.innerHTML = "";
          doc.body.style.cssText =
            "margin:0;background:#000;height:100vh;display:flex;align-items:center;justify-content:center;";
          const video = doc.createElement("video");
          video.src = videoUrl;
          video.controls = true;
          video.autoplay = true;
          video.style.cssText = "max-width:100%;max-height:100%;";
          doc.body.appendChild(video);
          videoWindow.addEventListener("beforeunload", () =>
            window.URL.revokeObjectURL(videoUrl)
          );
        })
        .catch(() => {
          videoWindow.close();
          alert("Unable to load the video. Please try again.");
        });
    },
  },
  beforeDestroy() {
    this.unsubscribe();
    this.eventBus.$off("vendorName");
    this.eventBus.$off("partyName");
  },
};
</script>
<style>
.selected-menu {
  background-color: #fea01c;
  height: 35px !important;
  padding: 10px !important;
  margin-bottom: 5px !important;
  font-weight: 400 !important;
}
.vendor-btn {
  margin-right: 10px;
  border-radius: 15px;
  margin-top: 5px !important;
}
.marque-text {
  color: white;
  margin: 2px;
  font-weight: 500;
  font-style: italic;
  font-size: 16px;
}
.marque-bg {
  background-image: linear-gradient(to right, black, rgb(150, 148, 148));
  width: 25rem !important;
  border-radius: 5px !important;
}
.letsTalk {
  /* width: 15px; */
  /* height: 50px; */
  /* position: fixed; */
  top: 2%;
  /* right: 0; */
  /* background-color: black; */
  z-index: 200;
  border-radius: 8px;
  /* border-top-left-radius: 8px;
  border-bottom-left-radius: 8px; */
  /* box-shadow: #003145 4px 4px 4px; */
  padding: 5px;
  /* transition: width 0.7s ease; */
}
.routeClass {
  background-color: rgb(80, 80, 158) !important;
}

.manual-videos-dropdown {
  display: inline-block;
  vertical-align: middle;
}
.manual-videos-dropdown .dropdown-menu {
  z-index: 9999;
  min-width: 260px;
}
.manual-videos-dropdown .manual-video-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 4px 12px;
}
.manual-videos-dropdown .manual-video-label {
  margin-right: 12px;
  white-space: nowrap;
}
.manual-videos-dropdown .manual-video-actions {
  display: flex;
  white-space: nowrap;
}
.manual-videos-dropdown .manual-video-actions a {
  padding: 4px !important;
  margin: 0 !important;
}
.manual-videos-dropdown .manual-video-actions .md-icon {
  font-size: 18px !important;
  width: 18px;
  min-width: 18px;
  height: 18px;
  color: #555 !important;
  font-weight: 300;
}
.manual-videos-dropdown .manual-video-actions a:hover .md-icon {
  color: #222 !important;
}
</style>
